import React, { useState } from 'react';
import styled from 'styled-components';

import { isEmbedded } from '../../../config/paths';
import { __ } from '../../../i18n/l10n';

import { Button } from './Button';
import CloseButton from './CloseButton';
import { Modal } from './Modal';

const Wrapper = styled.div`
  width: 100%;
  height: 1.87em;
  display: flex;
  justify-content: flex-end;
`;

const TopText = styled.p`
  margin-bottom: 2em;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

type CloseAppButtonProps = {
  className?: string;
};

function CloseAppButton({ className }: CloseAppButtonProps) {
  const [isCloseDialogOpen, setIsCloseDialogOpen] = useState(false);

  const handleOpenCloseDialog = () => {
    setIsCloseDialogOpen(true);
  };
  const handleCloseDialog = () => setIsCloseDialogOpen(false);

  const handleConfirmCloseReg = () => {
    window.location.href = 'wam://close';
  };

  return (
    <Wrapper>
      {isEmbedded ? (
        <>
          <CloseButton className={className} onClick={handleOpenCloseDialog} />
          <Modal
            isOpen={isCloseDialogOpen}
            onClose={handleCloseDialog}
            contentLabel={__('Leaving us already?')}
          >
            <TopText>{__('It would be a shame to stop so close to the finish line!')}</TopText>
            <ButtonsWrapper>
              <Button onClick={handleCloseDialog}>{__('Continue')}</Button>
              <Button theme={'secondary'} onClick={handleConfirmCloseReg}>{__('Leave')}</Button>
            </ButtonsWrapper>
          </Modal>
        </>
      ) : null}
    </Wrapper>
  );
}

export default CloseAppButton;
